import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { Head } from "@cinch-nx/landing-ui-shared";
import { Wrapper } from "@cinch-nx/shared-ui";
import { useEffect, useState } from "react";
import { ReviewCardsList, ReviewHubPagination, ReviewsHubFilters, ReviewsPageHeader } from "../lib/components";
import styles from "./car-reviews-hub.module.css";
export function CarReviewsHubFeature(param) {
    var _preview = param.preview, preview = _preview === void 0 ? false : _preview, _isISR = param.isISR, isISR = _isISR === void 0 ? false : _isISR, story = param.story, makeOptions = param.makeOptions, modelOptions = param.modelOptions, generatedAt = param.generatedAt, currentPage = param.currentPage, numberOfReviews = param.numberOfReviews, resultsPerPage = param.resultsPerPage, reviews = param.reviews, selectedMake = param.selectedMake, selectedModel = param.selectedModel;
    var content = useStoryblokState({
        story: story,
        enableBridge: preview
    }).content;
    var ref = content !== null && content !== void 0 ? content : {
        title: "Loading",
        subtitle: "Loading..."
    }, title = ref.title, subtitle = ref.subtitle;
    var ref1;
    var ref2 = _sliced_to_array((ref1 = content === null || content === void 0 ? void 0 : content.SEO) !== null && ref1 !== void 0 ? ref1 : [
        {}
    ], 1), SEO = ref2[0];
    var ref3 = useState(false), isLoading = ref3[0], setIsLoading = ref3[1];
    useEffect(function() {
        setIsLoading(false);
    }, [
        reviews
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, _object_spread_props(_object_spread({}, SEO), {
                generatedAt: generatedAt,
                fallbackTitle: "Cars Without The Faff - cinch",
                fallbackDescription: "Welcome to cinch, the faff free way to buy & sell cars. We have thousands of used cars, ready to be sold to you."
            })),
            /*#__PURE__*/ _jsx("article", {
                className: styles.page,
                children: /*#__PURE__*/ _jsxs(Wrapper, {
                    isSlim: true,
                    children: [
                        /*#__PURE__*/ _jsx(ReviewsPageHeader, {
                            title: title,
                            subtitle: subtitle
                        }),
                        /*#__PURE__*/ _jsx(ReviewsHubFilters, {
                            selectedMake: selectedMake,
                            selectedModel: selectedModel,
                            makes: makeOptions,
                            models: modelOptions,
                            isLoading: isLoading,
                            setIsLoading: setIsLoading,
                            isISR: isISR
                        }),
                        /*#__PURE__*/ _jsx(ReviewCardsList, {
                            reviews: reviews,
                            page: currentPage,
                            isLoading: isLoading,
                            selectedMake: selectedMake,
                            selectedModel: selectedModel
                        }),
                        /*#__PURE__*/ _jsx(ReviewHubPagination, {
                            currentPage: currentPage,
                            total: numberOfReviews,
                            resultsPerPage: resultsPerPage,
                            isISR: isISR
                        })
                    ]
                })
            })
        ]
    });
}
